export default __webpack_public_path__ + "static/media/snow.47fe727a.svg";